import { supabase } from '../services/supabase';

// Router guard to redirect unauthenticated users to login
export async function authGuard(): Promise<boolean> {
  console.log('🔒 Auth Guard: Checking authentication...');
  const { data: { session } } = await supabase.auth.getSession();

  if (!session) {
    console.log('❌ Auth Guard: No session found. Redirecting to /login');
    // Redirect to login if no session
    window.location.href = '/login';
    return false;
  }

  console.log('✅ Auth Guard: User authenticated', { email: session.user.email });
  return true;
}

// Admin-only guard
export async function adminGuard(): Promise<boolean> {
  const { data: { session } } = await supabase.auth.getSession();

  if (!session) {
    window.location.href = '/login';
    return false;
  }

  // Fetch user profile to check role
  const { data: profile } = await supabase
    .from('profiles')
    .select('role')
    .eq('id', session.user.id)
    .single();

  if ((profile as any)?.role !== 'admin') {
    // Redirect to home if not admin
    window.location.href = '/';
    return false;
  }

  return true;
}
